/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcessedJoinRequest } from './ProcessedJoinRequest';
import {
    ProcessedJoinRequestFromJSON,
    ProcessedJoinRequestFromJSONTyped,
    ProcessedJoinRequestToJSON,
    ProcessedJoinRequestToJSONTyped,
} from './ProcessedJoinRequest';
import type { ApprovedUserToMove } from './ApprovedUserToMove';
import {
    ApprovedUserToMoveFromJSON,
    ApprovedUserToMoveFromJSONTyped,
    ApprovedUserToMoveToJSON,
    ApprovedUserToMoveToJSONTyped,
} from './ApprovedUserToMove';

/**
 * 
 * @export
 * @interface ProcessJoinRequestsResult
 */
export interface ProcessJoinRequestsResult {
    /**
     * 
     * @type {string}
     * @memberof ProcessJoinRequestsResult
     */
    org_code: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessJoinRequestsResult
     */
    total_processed: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessJoinRequestsResult
     */
    successful: number;
    /**
     * 
     * @type {number}
     * @memberof ProcessJoinRequestsResult
     */
    failed: number;
    /**
     * 
     * @type {Array<ProcessedJoinRequest>}
     * @memberof ProcessJoinRequestsResult
     */
    results: Array<ProcessedJoinRequest>;
    /**
     * 
     * @type {Array<ApprovedUserToMove>}
     * @memberof ProcessJoinRequestsResult
     */
    approved_users_to_move: Array<ApprovedUserToMove>;
}

/**
 * Check if a given object implements the ProcessJoinRequestsResult interface.
 */
export function instanceOfProcessJoinRequestsResult(value: object): value is ProcessJoinRequestsResult {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('total_processed' in value) || value['total_processed'] === undefined) return false;
    if (!('successful' in value) || value['successful'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('approved_users_to_move' in value) || value['approved_users_to_move'] === undefined) return false;
    return true;
}

export function ProcessJoinRequestsResultFromJSON(json: any): ProcessJoinRequestsResult {
    return ProcessJoinRequestsResultFromJSONTyped(json, false);
}

export function ProcessJoinRequestsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessJoinRequestsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'total_processed': json['total_processed'],
        'successful': json['successful'],
        'failed': json['failed'],
        'results': ((json['results'] as Array<any>).map(ProcessedJoinRequestFromJSON)),
        'approved_users_to_move': ((json['approved_users_to_move'] as Array<any>).map(ApprovedUserToMoveFromJSON)),
    };
}

export function ProcessJoinRequestsResultToJSON(json: any): ProcessJoinRequestsResult {
    return ProcessJoinRequestsResultToJSONTyped(json, false);
}

export function ProcessJoinRequestsResultToJSONTyped(value?: ProcessJoinRequestsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'total_processed': value['total_processed'],
        'successful': value['successful'],
        'failed': value['failed'],
        'results': ((value['results'] as Array<any>).map(ProcessedJoinRequestToJSON)),
        'approved_users_to_move': ((value['approved_users_to_move'] as Array<any>).map(ApprovedUserToMoveToJSON)),
    };
}

